function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Padding__x26__Artboard"
});

var SvgPlayIcon = function SvgPlayIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.87516,29.39117c0.02997,0.04999,0.06,0.10999,0.09998,0.15997h-0.22998v-0.20001   c0-0.01996,0.01001-0.04999,0.01001-0.07996h0.02997C33.81517,29.31115,33.84513,29.35113,33.87516,29.39117z",
    style: {
      fill: "#91CAFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.87516,29.39117c0.02997,0.04999,0.06,0.10999,0.09998,0.15997h-0.22998v-0.20001   c0-0.01996,0.01001-0.04999,0.01001-0.07996h0.02997C33.81517,29.31115,33.84513,29.35113,33.87516,29.39117z",
    style: {
      fill: "#91CAFF"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.67912,18.27638v11.44465c0,0.70827,0.75425,1.16158,1.37969,0.8292l10.76762-5.72233    c0.66447-0.35312,0.66447-1.30527,0-1.6584l-10.76762-5.72233C18.43337,17.1148,17.67912,17.56811,17.67912,18.27638z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.81172,24.04824c0.05923,0.25154,0.03469,0.52423-0.1053,0.79725    c-0.3537,0.68979-1.09298,1.06192-1.73441,1.43452c-0.76426,0.44394-1.48366,0.96556-2.21903,1.45516    c-1.37614,0.91622-2.77385,1.79827-4.23529,2.57326c-0.15416,0.08175-0.30832,0.1635-0.46248,0.24525    c-0.62,0.33002-1.38-0.12-1.38-0.82996V18.27371c0-0.18999,0.05999-0.36997,0.14986-0.50985    c-0.42011,0.65635,6.11824,3.81615,6.71301,4.11301c0.69221,0.3455,1.38671,0.67513,2.08422,1.00982    C27.12662,23.12868,27.67488,23.46715,27.81172,24.04824z",
    style: {
      fill: "#B9D4F8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.30265,25.68581c0.04457,0.18927,0.0261,0.39445-0.07921,0.59986    c-0.25792,0.50303-0.80732,0.75645-1.26399,1.04386c-1.63291,1.02768-3.18928,2.16099-4.89783,3.0669    c-0.116,0.06151-0.232,0.12303-0.348,0.18454c-0.46653,0.24833-1.03842-0.09029-1.03842-0.62452v-8.61582    c0-0.14296,0.04514-0.27839,0.11277-0.38365c-0.31612,0.49389,4.60381,2.87155,5.05135,3.09493    c0.52087,0.25998,1.04346,0.50802,1.56832,0.75986C24.78713,24.99387,25.19969,25.24855,25.30265,25.68581z",
    style: {
      fill: "#659BDB"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "     M17.67912,18.27638v11.44465c0,0.70827,0.75425,1.16158,1.37969,0.8292l10.76762-5.72233     c0.66447-0.35312,0.66447-1.30527,0-1.6584l-10.76762-5.72233C18.43337,17.1148,17.67912,17.56811,17.67912,18.27638z",
    style: {
      fill: "none",
      stroke: "#1B4A9A",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B4A9A",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 20.19262,
    x2: 22.94968,
    y1: 20.18496,
    y2: 21.5635
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B4A9A",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 24.40078,
    x2: 25.08561,
    y1: 22.32532,
    y2: 22.64812
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Play_icon.788c3ffe.svg";
export { ForwardRef as ReactComponent };